export default __webpack_public_path__ + "static/media/element_35.18a0d7ae.webp";